export interface SubCategory {
  id: string;
  name: string;
}

export interface ProductCategory {
  id: string;
  name: string;
  key: string;
  subCategories: SubCategory[];
}

export const CATEGORIES: ProductCategory[] = [
  {
    id: '1',
    name: 'Automation and Communication',
    key: 'automationAndCommunication',
    subCategories: [
      { id: 'ac-1', name: 'MicroSCADA' },
      { id: 'ac-2', name: 'IED' },
      { id: 'ac-3', name: 'RTU' },
      { id: 'ac-4', name: 'Protection Relay' },
      { id: 'ac-5', name: 'Network Management' },
    ],
  },
  {
    id: '2',
    name: 'Enterprise Software Solutions',
    key: 'enterpriseSoftwareSolutions',
    subCategories: [
      { id: 'es-1', name: 'Asset Suite' },
      { id: 'es-2', name: 'Ellipse' },
      { id: 'es-3', name: 'EAM' },
      { id: 'es-4', name: 'APM' },
    ],
  },
  {
    id: '3',
    name: 'Grid & Power Quality Solutions',
    key: 'gridAndPowerQualitySolutions',
    subCategories: [
      { id: 'gp-1', name: 'STATCOM' },
      { id: 'gp-2', name: 'SVC' },
      { id: 'gp-3', name: 'Filters' },
      { id: 'gp-4', name: 'Energy Storage' },
    ],
  },
  {
    id: '4',
    name: 'High Voltage Products',
    key: 'highVoltageProducts',
    subCategories: [
      { id: 'hv-1', name: 'Circuit Breakers' },
      { id: 'hv-2', name: 'Disconnectors' },
      { id: 'hv-3', name: 'Instrument Transformers' },
      { id: 'hv-4', name: 'Surge Arresters' },
    ],
  },
  {
    id: '5',
    name: 'Transformers',
    key: 'transformers',
    subCategories: [
      { id: 'tr-1', name: 'Power Transformers' },
      { id: 'tr-2', name: 'Distribution Transformers' },
      { id: 'tr-3', name: 'Dry-Type Transformers' },
      { id: 'tr-4', name: 'Special Transformers' },
    ],
  },
];
export const ASSETS_SEARCH_DESCRIPTION = 'Select the type of products that interests you to proceed or search. Search using Serial Number or Asset ID.';
export const NO_PRODUCT_CATEGORIES_MESSAGE = 'Based on your customer ID, there are no products available under this category.';